import {
  Homepage,
  DashboardPage,
  ClientListPage,
  ClientDetailPage,
  ProjectListPage,
  EpicListPage,
  SprintListPage,
  BacklogPage,
  BoardPage,
  TaskDetailPage,
  TimesheetPage,
  ReportsPage,
  TicketListPage,
  TicketNewPage,
  TicketDetailPage,
  UserListPage,
} from "../../pages";

export const routes = {
  home: "/",
  dashboard: "/dashboard",
  clients: "/clients",
  clientDetail: "/clients/:id",
  projects: "/projects",
  projectBoard: "/projects/:id/board",
  projectBacklog: "/projects/:id/backlog",
  projectEpics: "/projects/:id/epics",
  projectSprints: "/projects/:id/sprints",
  taskDetail: "/tasks/:id",
  myTime: "/my-time",
  reports: "/reports",
  adminUsers: "/admin/users",
  tickets: "/support",
  newTicket: "/support/tickets/new",
  ticketDetail: "/support/tickets/:id",
};

export const Pages = [
  { path: routes.home, protected: false, component: <Homepage /> },
  { path: routes.dashboard, protected: true, component: <DashboardPage /> },
  { path: routes.clients, protected: true, component: <ClientListPage /> },
  { path: routes.clientDetail, protected: true, component: <ClientDetailPage /> },
  { path: routes.projects, protected: true, component: <ProjectListPage /> },
  { path: routes.projectBoard, protected: true, component: <BoardPage /> },
  { path: routes.projectBacklog, protected: true, component: <BacklogPage /> },
  { path: routes.projectEpics, protected: true, component: <EpicListPage /> },
  { path: routes.projectSprints, protected: true, component: <SprintListPage /> },
  { path: routes.taskDetail, protected: true, component: <TaskDetailPage /> },
  { path: routes.myTime, protected: true, component: <TimesheetPage /> },
  { path: routes.reports, protected: true, component: <ReportsPage /> },
  { path: routes.adminUsers, protected: true, component: <UserListPage /> },
  { path: routes.tickets, protected: true, component: <TicketListPage /> },
  { path: routes.newTicket, protected: true, component: <TicketNewPage /> },
  { path: routes.ticketDetail, protected: true, component: <TicketDetailPage /> },
];
